import React, { useState } from "react";
import styled from "styled-components";
import {
  Card,
  Dialog,
  LineDiagram,
  type LineDiagramTypes,
} from "@origo/sp-lib";
import TurbineSettings from "./components/TurbineSettings";
import { SingleLineProvider } from "./context/provider";
import { useSingleLine } from "./context/context";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const DiagramContainer = styled.div`
  display: flex;
  height: 70%;
  width: 100%;
`;

export default function SingleLineNew() {
  return (
    <SingleLineProvider>
      <Component />
    </SingleLineProvider>
  );
}

function Component() {
  const { singleLineConfig } = useSingleLine();
  const [nodeSelected, setNodeSelected] = useState<LineDiagramTypes.Node>();

  function handleNodeClick(a: LineDiagramTypes.Node) {
    if (a.type === "turbine") {
      setNodeSelected(a);
    }
  }

  function handleClose() {
    setNodeSelected(undefined);
  }

  return (
    <Container>
      <DiagramContainer>
        {singleLineConfig && (
          <LineDiagram
            diagram={{
              nodes: singleLineConfig.nodes,
              edges: singleLineConfig.edges,
            }}
            viewport={{ x: 500, y: 0, zoom: 1 }}
            onNodeClick={handleNodeClick}
          />
        )}

        <Dialog.Root
          open={!!nodeSelected}
          setOpen={handleClose}
          title={`Turbine ${nodeSelected?.data.title}`}
          variant="primary"
        >
          <Dialog.Content className="size-full">
            {nodeSelected && <TurbineSettings node={nodeSelected} />}
          </Dialog.Content>
        </Dialog.Root>
      </DiagramContainer>
      <Card
        variant="secondary"
        className="flex flex-1 w-full text-center justify-center"
      >
        Detailed information section
      </Card>
    </Container>
  );
}
